import FileSharePage from "../FileShareFeature"
import ShareLandingPage from "../FileShareFeature/ShareLandingPage"
import ReceivePage from "../ReceiveFeature/ReceivePage"
import NotFoundPage from "./NotFoundPage"
import Account from "../Account"
import Pricing from "./Pricing"
import FeaturesPage from "./FeaturesPage"
import PrivacyPolicyPage from "./PrivacyPolicyPage"
import TermsOfUsePage from "./TermsOfUsePage"
import HelpCenterRoutes from "aldoo-ra/HelpCenter/routes"
import BlogHome from "../Blog/home"
import BlogPostPage from "./BlogPostPage"
import TransferBrowser from "../TransferBrowser"
import { adminRole } from "aldoo-ra/RBAC"

// Register all site page routes at once using an object.
// File share is the home page of Aldoo Transfer.
export default {
  "/": FileSharePage,
  "/s/*": ShareLandingPage,
  "/r/*": ReceivePage,
  "/account": Account,
  "/account/*": Account,
  "/pricing": Pricing,
  "/features": FeaturesPage,
  "/privacy-policy": PrivacyPolicyPage,
  "/terms-of-use": TermsOfUsePage,
  "/blog": BlogHome,
  "/blog/*": BlogPostPage,
  "/admin/transfers*": adminRole(TransferBrowser),
  "/404": NotFoundPage,
  ...HelpCenterRoutes,
}

// Per-route options. noLanguagePrefix: true — route manages its own language/UI.
export const routeOptions = {
  "/s/*": { noLanguagePrefix: true },
  "/r/*": { noLanguagePrefix: true },
}
